import React from "react"
import ReactDOMServer from "react-dom/server";
import { AiFillCaretDown } from "react-icons/ai";
import COLORS from "scss/colors.module.scss";
import { DIMENSIONS } from "utils/Dimensions";
import { getTitle } from "../../helpers/getTitle";

var clickCount = 0;

export default class MultiselectColumnRenderer {

  getChips(valuesArrToShow, width) {
    var temp = [];
    valuesArrToShow.map((valArr, index) => {
      temp.push(`<div
        key=${index}
        class="d-flex"
        >
        <div
          class="multiSelectChipsContainer"
        >
          <div
            class="multiSelectChip"
            style="color:${COLORS.PRIMARY_COLOR};
            background-color:${(valArr ? valArr.background : "transparent")};
            max-width: ${Number(width)/2 - 20}px;
              "
          >
            ${(valArr ? valArr.label : "")}
          </div>
        </div>
        </div>`
      )
    }
    )
    return temp.join("");
  }

  showDownArrow(params) {
    if (params.value !== undefined) {
      return ReactDOMServer.renderToStaticMarkup(<AiFillCaretDown />)
    }
    return ""
  }

  init(params) {
    this.params = params;
    if (params.data?.row_id == "+") {
      this.htmlElement = "";
      return;
    }
    var options = [];
    var columnOptions = params.columnOptions;
    columnOptions.options.map((option, index) => {
      options.push({
        label: typeof option == "string" ? option.trim() : option,
        background: columnOptions.colors?.[index] || "grey",
      });
      return 0;
    });
    var values = params.value ? params.value?.split(",") : [];
    var valuesArrToShow = [],
      temp;
    values.map((value) => {
      temp = options.find((option) => option.label === value.trim());
      if (temp) {
        valuesArrToShow.push(temp);
      } else if (value) {
        value = typeof value == "string" ? value.trim() : value;
        let opt = {
          label: value,
          background: "grey",
        };
        valuesArrToShow.push(opt);
      }
      return 0;
    });

    this.clickHandler = function clickHandler() {
      clickCount = clickCount + 1
      if (
        clickCount > 1 && 
        params.store.prevClickedCellRowId ===
          params.api.getFocusedCell()?.rowIndex &&
        params.store.prevClickedCellColumnId ===
          params.api.getFocusedCell()?.column.colDef.cellRendererParams.columnId
      ) {
        params.api.startEditingCell({
          colKey: params.colDef.colId,
          rowIndex: params.rowIndex,
        });
        clickCount = 0;
      }
    }

    this.agGridProps = params;

    this.htmlElement = document.createElement('div')
    this.htmlElement.className = "multiSelectCellContainer"
    this.htmlElement.style = "flexWrap: "
      + (params.node.rowHeight <= DIMENSIONS.cell_height_medium
        ? "nowrap"
        : "wrap")
    this.htmlElement.title = getTitle(params, params.cellMetaData)
    this.htmlElement.onclick = this.clickHandler
    this.htmlElement.innerHTML = ` <div
                                  class="multiSelectCellContainer multiSelectCell"
                                  id="multiSelectCell"
                                  style="width: ${
                                    Number(params.colDef.width) - 25
                                  }px;
                                    max-height: ${
                                      params.node.rowHeight
                                    }px; padding-top:${
      params.node.rowHeight <= DIMENSIONS.cell_height_short ? "7px" : "0px"
    }"
                                >
                                  ${this.getChips(
                                    valuesArrToShow,
                                    params.colDef.width
                                  )}
                                </div>
                                <div class="multiselect_down_arrow">
                                  ${this.showDownArrow(params)}
                                </div>`
  }

  getGui() {
    return this.htmlElement;
  };

  destroy() {
    clickCount = 0
  }
}